/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferPackage
 */
export interface TransferPackage {
    /**
     * 
     * @type {number}
     * @memberof TransferPackage
     */
    fileCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferPackage
     */
    objectKey?: string;
    /**
     * Identifier of package
     * @type {string}
     * @memberof TransferPackage
     */
    packageId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPackage
     */
    packageType?: TransferPackagePackageTypeEnum;
    /**
     * Identifier of SIP
     * @type {string}
     * @memberof TransferPackage
     */
    sipId: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPackage
     */
    status: TransferPackageStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof TransferPackage
     */
    statusUpdatedAt: Date;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof TransferPackage
     */
    transferId?: string;
}


/**
 * @export
 */
export const TransferPackagePackageTypeEnum = {
    Aip: 'AIP',
    Dip: 'DIP'
} as const;
export type TransferPackagePackageTypeEnum = typeof TransferPackagePackageTypeEnum[keyof typeof TransferPackagePackageTypeEnum];

/**
 * @export
 */
export const TransferPackageStatusEnum = {
    Created: 'Created',
    Validated: 'Validated',
    Failed: 'Failed',
    SentToStorage: 'Sent to Storage',
    Stored: 'Stored',
    DisseminationRequested: 'Dissemination Requested',
    Disseminated: 'Disseminated',
    ReingestRequested: 'Reingest Requested',
    PreProcessing: 'Pre-Processing',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected'
} as const;
export type TransferPackageStatusEnum = typeof TransferPackageStatusEnum[keyof typeof TransferPackageStatusEnum];


/**
 * Check if a given object implements the TransferPackage interface.
 */
export function instanceOfTransferPackage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sipId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function TransferPackageFromJSON(json: any): TransferPackage {
    return TransferPackageFromJSONTyped(json, false);
}

export function TransferPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferPackage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileCount': !exists(json, 'file_count') ? undefined : json['file_count'],
        'objectKey': !exists(json, 'object_key') ? undefined : json['object_key'],
        'packageId': !exists(json, 'package_id') ? undefined : json['package_id'],
        'packageType': !exists(json, 'package_type') ? undefined : json['package_type'],
        'sipId': json['sip_id'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'transferId': !exists(json, 'transfer_id') ? undefined : json['transfer_id'],
    };
}

export function TransferPackageToJSON(value?: TransferPackage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_count': value.fileCount,
        'object_key': value.objectKey,
        'package_id': value.packageId,
        'package_type': value.packageType,
        'sip_id': value.sipId,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'transfer_id': value.transferId,
    };
}

